// extracted by mini-css-extract-plugin
export default {"products":"qB-z","card":"rB-z","oosMessaging":"sB-z"};